import { useToast } from '@chakra-ui/react';
import { useCallback, useRef } from 'react';
import { ONLINE_SALES } from '../../../services/apis';

export default function useSubscriptionCheckBeforeOrder({ cart = [], waiverId = '', getMemberTrx } = {}) {
    const toast = useToast();
    const subscriptionToastIdRef = useRef();

    const closeLoadingToast = useCallback(() => {
        if (subscriptionToastIdRef.current) {
            toast.close(subscriptionToastIdRef.current);
            subscriptionToastIdRef.current = undefined;
        }
    }, [toast]);

    const defaultGetMemberTrx = useCallback((items) => {
        const firstCartItem = (items || [])[0] || {};
        const minorsList = firstCartItem?.minors || [];

        return minorsList.map((item) => ({
            childrenID: item?.childrenID || item?.key || '',
            name: item?.name || '',
        }));
    }, []);

    const checkSubscriptionBeforeOrder = useCallback(
        async ({ values, onVerified } = {}) => {
            const isSubsProduct = (cart || []).some((item) => item?.menuType === 'subscription');
            if (!isSubsProduct) return false;

            closeLoadingToast();
            subscriptionToastIdRef.current = toast({
                title: 'Checking subscription',
                status: 'info',
                isClosable: true,
                duration: null,
            });

            try {
                const userId = waiverId || '';
                if (!userId) {
                    closeLoadingToast();
                    toast({
                        title: 'Subscription check failed',
                        description: 'User ID is missing.',
                        status: 'error',
                        duration: 4000,
                        isClosable: true,
                    });
                    return true;
                }


                const typesInCart = [...new Set(cart.map(item => item.menuType))];

                // Validasi jika bisnis melarang campuran tipe tertentu
                if (typesInCart.includes('party') && typesInCart.includes('subscription')) {
                     toast({
                        title: 'Maaf, pesanan Party dan Subscription tidak dapat digabung.',
                        status: 'error',
                        duration: 1500,
                        isClosable: true,
                    });
                }

                const memberTrx = (typeof getMemberTrx === 'function' ? getMemberTrx(cart) : defaultGetMemberTrx(cart)) || [];

                const res = await fetch(`${ONLINE_SALES.API_CHECK_PAYMENT_SUBSCRIPTION}?userID=${encodeURIComponent(userId)}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        memberTrx,
                    }),
                });

                let data = {};
                try {
                    data = await res.json();
                } catch (_) {
                    data = {};
                }

                closeLoadingToast();

                if (res.ok && data?.success && data?.acknowledge === 1) {
                    toast({
                        title: 'Subscription verified',
                        status: 'success',
                        duration: 1500,
                        isClosable: true,
                    });

                    if (typeof onVerified === 'function') {
                        onVerified(values, data);
                    }
                } else {
                    toast({
                        title: 'Subscription check failed',
                        description: data?.message || 'Subscription check failed.',
                        status: 'error',
                        duration: 4000,
                        isClosable: true,
                    });
                }
            } catch (err) {
                closeLoadingToast();
                toast({
                    title: 'Failed to check subscription status',
                    description: err?.message || 'Failed to check subscription status.',
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                });
            }

            return true;
        },
        [cart, waiverId, getMemberTrx, defaultGetMemberTrx, closeLoadingToast, toast],
    );

    return { checkSubscriptionBeforeOrder, closeLoadingToast };
}

